<template>
  <div class="external-login">
    <loading-logo :autoplay="true" ref="loadingLog"/>
  </div>
</template>

<script>
  import LoadingLogo from "../components/LoadingLogo";
  export default {
    components: {LoadingLogo},
    props: {
      token: {
        type: String
      }
    },
    mounted() {
      setTimeout(() => {
        this.$store.dispatch('auth/apiSignIn', this.token)
          .then(() => {
            this.$router.push('/');
            this.$refs.loadingLog.setLoading(false);
          })
          .catch(() => {
            this.$router.push({
              name: 'Login'
            })
            this.$refs.loadingLog.setLoading(false);
          })
      }, 1500)
    }
  }
</script>

<style lang="scss">
@import "ExternalLogin";
</style>
